import { LitElement, html, svg } from 'lit';

export class IconInfo16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Sirkel med bokstaven I</title><path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.5" d="M8 7.5v4"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 4v.5"></path><path stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5" d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Z"></path></svg>`; }
}
if (!customElements.get('f-icon-info16', IconInfo16)) {
  customElements.define('f-icon-info16', IconInfo16);
}